import React, { useEffect, useState } from "react";
import { SeleccionarOferente } from "../../../actions/compras/Cotizaciones";
import ComprasService from "../../../services/ComprasService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Container,
  Grid,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { BUSCADOR_CENTRAL } from "../../../utils/constants";

export const BuscadorOferente = (props) => {

  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [textoBuscado, setTextoBuscado] = useState("");
  const cargando = open && options.length === 0;

  const handleInputChange = (e) => {
    let typingTimer = null
    if (e.target.value.length >= BUSCADOR_CENTRAL.CARACTERES_MINIMOS_AFILIACIONES) {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        setTextoBuscado(e.target.value);
      }, BUSCADOR_CENTRAL.MILISEG_SIN_CAMBIOS);
    };
  };

  const handleOferenteSeleccionado = (oferente) => {
    if (oferente !== null) {
      dispatch(SeleccionarOferente(oferente))
    }
  };


  useEffect(() => {
    let active = true;
    (async () => {
      let texto = textoBuscado.replace("/", "__");
      if (texto.length > 0) {
        const response = await ComprasService.BuscadorOferente(texto);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (active && lista.length > 0) {
            setOptions(
              lista
            );
          }
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [textoBuscado]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);



  return (
    <>
      <Grid container>
        <Grid item xs={12} style={{ display: 'flex', margin: 'auto' }}>
          <Container
          >
            <Autocomplete
              style={{
                padding: 6,
                backgroundColor: "#FAFAFA",
                borderRadius: "5px",
              }}
              loadingText="Buscando..."
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              onChange={(e, newValue) => {
                handleOferenteSeleccionado(newValue);
              }}
              getOptionSelected={(option, value) =>
                option.idOferente === value.idOferente
              }
              getOptionLabel={(option) =>
                `${option.razonSocial} ${option.cuit}`
              }
              renderOption={(option) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span>{`${option.razonSocial}`}</span>
                  <span
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {" "}
                    {`CUIT: ${option.cuit}`}
                  </span>
                </div>
              )}
              options={options}
              loading={cargando}
              renderInput={(params) => (
                <TextField
                  onChange={handleInputChange}
                  style={{
                    padding: 3,
                  }}
                  {...params}
                  variant="outlined"
                  label="Nombre | CUIT"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {cargando ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Container>
        </Grid>
      </Grid>
    </>
  );
};